module.exports = __webpack_public_path__ + "media/images/menu/triangulum_australe-ce76c0a0108236803b4ccedad78e14ed.jpg";